const Backbone = require('backbone');
const Dispatcher = require('common/domain/repository/dispatcher');

const SIDefinitionURI = 'http://www.bipm.org/en/publications/si-brochure/';

const quantityKinds = [
    {
        id: 'length',
        type: 'SimpleQuantityKind',
        symbol: 'l'
    },
    {
        id: 'mass',
        type: 'SimpleQuantityKind',
        symbol: 'm'
    },
    {
        id: 'time',
        type: 'SimpleQuantityKind',
        symbol: 't'
    },
    {
        id: 'electric current',
        type: 'SimpleQuantityKind',
        symbol: 'I'
    },
    {
        id: 'thermodynamic temperature',
        type: 'SimpleQuantityKind',
        symbol: 'T'
    },
    {
        id: 'amount of substance',
        type: 'SimpleQuantityKind',
        symbol: 'n'
    },
    {
        id: 'luminous intensity',
        type: 'SimpleQuantityKind',
        symbol: 'I_v'
    },
    {
        id: 'force',
        type: 'DerivedQuantityKind',
        symbol: 'F',
        factor: [
            {
                quantityKind: 'mass',
                exponent: [1, 1]
            },
            {
                quantityKind: 'length',
                exponent: [1, 1]
            },
            {
                quantityKind: 'time',
                exponent: [-2, 1]
            }
        ]
    }
];

const prefixes = [
    {
        id: 'kilo',
        symbol: 'k',
        factor: 1000
    },
    {
        id: 'mega',
        symbol: 'm',
        factor: 1000 * 1000
    }
];
const Prefix = Backbone.Model.extend({
    getSymbol: function() {
        return this.get('symbol');
    }
});
const PrefixCollection = Backbone.Collection.extend({
    model: Prefix
});
const prefixCollection = new PrefixCollection(prefixes);

const units = [
    {
        id: 'meter',
        type: 'SimpleUnit',
        symbol: 'm',
        quantityKind: ['length'],
        definitionURI: SIDefinitionURI
    },
    {
        id: 'gram',
        type: 'SimpleUnit',
        symbol: 'g',
        quantityKind: ['mass'],
        definitionURI: SIDefinitionURI
    },
    {
        id: 'second',
        type: 'SimpleUnit',
        symbol: 's',
        quantityKind: ['time'],
        definitionURI: SIDefinitionURI
    },
    {
        id: 'ampere',
        type: 'SimpleUnit',
        symbol: 'A',
        quantityKind: ['electric current'],
        definitionURI: SIDefinitionURI
    },
    {
        id: 'kelvin',
        type: 'SimpleUnit',
        symbol: 'K',
        quantityKind: ['thermodynamic temperature'],
        definitionURI: SIDefinitionURI
    },
    {
        id: 'mole',
        type: 'SimpleUnit',
        symbol: 'mol',
        quantityKind: ['amount of substance'],
        definitionURI: SIDefinitionURI
    },
    {
        id: 'candela',
        type: 'SimpleUnit',
        symbol: 'cd',
        quantityKind: ['luminous intensity'],
        definitionURI: SIDefinitionURI
    },
    {
        id: 'kilogram',
        type: 'PrefixedUnit',
        prefix: 'kilo',
        referenceUnit: 'gram',
        definitionURI: SIDefinitionURI
    },
    {
        id: 'newton',
        type: 'DerivedUnit',
        symbol: 'N',
        factor: [
            {
                unit: 'kilogram',
                exponent: [1, 1]
            },
            {
                unit: 'meter',
                exponent: [1, 1]
            },
            {
                unit: 'second',
                exponent: [-2, 1]
            }
        ],
        definitionURI: SIDefinitionURI
    }
];

const Unit = Backbone.Model.extend({
    getSymbol: function() {
        let s = this.get('symbol');
        if(!s) {
            throw `symbol is not defined: ${this.get('type')}`;
        }
        return s;
    },
    /**
     * TODO
     * この Unit の Value を別の Unit で表示した値を返す
     *
     * @param value
     * @param unit
     */
    convert: function(value, unit) {
        throw 'Not implemented!'
    },
    toJSON: function() {
        let j = Unit.__super__.toJSON.call(this);
        j.symbol = this.getSymbol();

        return j;
    }
});
const SimpleUnit = Unit.extend();
const DerivedUnit = Unit.extend();
const PrefixedUnit = Unit.extend({
    getSymbol: function() {
        let s = this.get('symbol');
        if(s) {
            return s;
        }
        let unit = this.collection.get(this.get('referenceUnit'));
        let prefix = prefixCollection.get(this.get('prefix'));
        return prefix.getSymbol() + unit.getSymbol();
    }
});
const UnitCollection = Backbone.Collection.extend({
    model: function(attrs, options) {
        if(!attrs.type) {
            throw 'type is not specified: ' + JSON.stringify(attrs);
        }

        if(attrs.type == 'SimpleUnit') {
            return new SimpleUnit(attrs, options);
        }
        if(attrs.type == 'PrefixedUnit') {
            return new PrefixedUnit(attrs, options);
        }
        if(attrs.type == 'DerivedUnit') {
            return new DerivedUnit(attrs, options);
        }

        throw 'No type is found: ' + attrs.type;
    }
});

const UnitStore = Backbone.Model.extend({
    initialize: function() {
        this._units = new UnitCollection(units);
        Dispatcher.register(this.dispatch);
    },

    clearAll: function() {
        this._units = new UnitCollection(units);
    },

    getUnits: function() {
        return this._units;
    },

    dispatch: function(action) {}
});

module.exports = new UnitStore();



// WEBPACK FOOTER //
// ./system/domain/repository/unit.js